/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WritingInputs */

const en_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing`)
};

const es_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escritura / Redacción`)
};

const fr_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écriture`)
};

const de_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreiben`)
};

const ja_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライティング`)
};

const zh_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写作`)
};

const ar_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كتابة`)
};

const id_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penulisan`)
};

const it_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrittura / Copywriting`)
};

const ru_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Написание текстов`)
};

const pt_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrita`)
};

const ko_val_writing = /** @type {(inputs: Val_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`작문`)
};

/**
* | output |
* | --- |
* | "Writing" |
*
* @param {Val_WritingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_writing = /** @type {((inputs?: Val_WritingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WritingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_writing(inputs)
	if (locale === "es") return es_val_writing(inputs)
	if (locale === "fr") return fr_val_writing(inputs)
	if (locale === "de") return de_val_writing(inputs)
	if (locale === "ja") return ja_val_writing(inputs)
	if (locale === "zh") return zh_val_writing(inputs)
	if (locale === "ar") return ar_val_writing(inputs)
	if (locale === "id") return id_val_writing(inputs)
	if (locale === "it") return it_val_writing(inputs)
	if (locale === "ru") return ru_val_writing(inputs)
	if (locale === "pt") return pt_val_writing(inputs)
	return ko_val_writing(inputs)
});